import React, { useState, useContext, useEffect } from 'react';
import {useLocation, useNavigate, NavLink} from 'react-router-dom';
import '../navigation.css';






const NavbarResponsive = () => {

    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
   



    useEffect(() => {
        const navLinks = document.querySelectorAll('.nav-Link');
        navLinks.forEach(link => {
            const parent = link.parentElement;
            if (link.getAttribute('href') === location.pathname) {
                parent.classList.add('active');
            } else {
                parent.classList.remove('active');
            }
            
         });
    }, [location]);




    return (
        <nav className="pgnav">

                <button
                    className="menuButton"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? "✕" : "☰"}
                </button>

                <div className={`navigationsLeiste ${isOpen ? "open" : ""}`}>
                        <ul className="navRight">
                            <li className="nav-item">
                                <NavLink to="/" onClick={() => setIsOpen(false)} className="nav-link" activeClassName="active">
                                    Home
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/sysmobil" onClick={() => setIsOpen(false)} className="nav-link" activeClassName="active">
                                    Sys.Mobil
                                </NavLink>
                            </li>

                           

                            <li className="nav-item">
                                <NavLink to="/kontakt" onClick={() => setIsOpen(false)} className="nav-link" activeClassName="active">
                                    Kontakt
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                

            </nav>
      );

};


 
export default NavbarResponsive;

